export const AUTH_QUERY_PARAMETERS = ['code', 'state', 'client_id', 'return_url', 'grant_type', 'working_platform'];

export const ACCESS_TYPE: { [key: string]: string } = {
  link_auto_login_code: 'autoLoginCode',
  external_sync_code: 'autoLoginCode',
  sync_token: 'kBankApp',
  authorization_code: 'normal'
};

export const BZNAV_PARTNER_EXTERNAL_ID_SESSION_KEY = 'B_PARTNER_EXTERNAL_ID';
export const SIGN_REQUIRED_STEP_COOKIE_KEY = `BZNAV_SIGN_REQUIRED_STEP.${process.env.NEXT_PUBLIC_ZENV}`;
